<template>
    <v-container fluid class="pa-0 contact-form--wrapper">
        <v-row column justify-center align-center>
            <v-col cols="12">
                <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
                    <v-form
                        id="contactForm"
                        ref="contactForm"
                        data-netlify="true"
                        data-netlify-honeypot="bot-field"
                        name="contactForm"
                        action="/contact/"
                        method="POST"
                        @submit.prevent="handleSubmit(handleSubmission)"
                    >
                        <input
                            id="form-name"
                            type="hidden"
                            name="form-name"
                            value="contactForm"
                        />
                        <v-container fluid class="contact-form--wrapper pa-0">
                            <v-row column justify-center align-center>
                                <v-col
                                    cols="12"
                                    md="6"
                                    :class="{
                                        'pr-0': $vuetify.breakpoint.mdAndUp,
                                        'pb-0': true, // $vuetify.breakpoint.smAndDown
                                    }"
                                >
                                    <ValidationProvider
                                        name="firstname"
                                        rules="required"
                                        class="validationWrapper"
                                    >
                                        <div slot-scope="{ errors }">
                                            <span class="validationMessage">
                                                {{ errors[0] }}
                                            </span>
                                            <v-text-field
                                                id="firstname"
                                                v-model="firstname"
                                                name="firstname"
                                                :label="localize('firstName')"
                                                outlined
                                                dense
                                                :hide-details="true"
                                            ></v-text-field>
                                        </div>
                                    </ValidationProvider>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="6"
                                    :class="{
                                        'pr-0': $vuetify.breakpoint.mdAndUp,
                                        'pb-0': true, // $vuetify.breakpoint.smAndDown
                                    }"
                                >
                                    <ValidationProvider
                                        name="lastname"
                                        rules="required"
                                        class="validationWrapper"
                                    >
                                        <div slot-scope="{ errors }">
                                            <span class="validationMessage">
                                                {{ errors[0] }}
                                            </span>
                                            <v-text-field
                                                id="lastname"
                                                v-model="lastname"
                                                name="lastname"
                                                :label="localize('lastName')"
                                                outlined
                                                dense
                                                :hide-details="true"
                                            ></v-text-field>
                                        </div>
                                    </ValidationProvider>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="6"
                                    :class="{
                                        'pr-0': $vuetify.breakpoint.mdAndUp,
                                        'pb-0': true, // $vuetify.breakpoint.smAndDown
                                    }"
                                >
                                    <ValidationProvider
                                        name="company"
                                        rules=""
                                        class="validationWrapper"
                                    >
                                        <div slot-scope="{ errors }">
                                            <span class="validationMessage">
                                                {{ errors[0] }}
                                            </span>
                                            <v-text-field
                                                id="company"
                                                v-model="company"
                                                name="company"
                                                :label="localize('company')"
                                                outlined
                                                dense
                                                :hide-details="true"
                                            ></v-text-field>
                                        </div>
                                    </ValidationProvider>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="6"
                                    :class="{
                                        'pr-0': $vuetify.breakpoint.mdAndUp,
                                        'pb-0': true, // $vuetify.breakpoint.smAndDown
                                    }"
                                >
                                    <ValidationProvider
                                        name="phone"
                                        rules="required"
                                        class="validationWrapper"
                                    >
                                        <div slot-scope="{ errors }">
                                            <span class="validationMessage">
                                                {{ errors[0] }}
                                            </span>
                                            <v-text-field
                                                id="phone"
                                                v-model="phone"
                                                v-mask="phoneMask"
                                                name="phone"
                                                :label="localize('phone')"
                                                outlined
                                                dense
                                                :hide-details="true"
                                            ></v-text-field>
                                        </div>
                                    </ValidationProvider>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="12"
                                    :class="{
                                        'pr-0': $vuetify.breakpoint.mdAndUp,
                                        'pb-0': true, // $vuetify.breakpoint.smAndDown
                                    }"
                                >
                                    <ValidationProvider
                                        name="email"
                                        rules="required|email|emoji"
                                        class="validationWrapper"
                                    >
                                        <div slot-scope="{ errors }">
                                            <span class="validationMessage">
                                                {{ errors[0] }}
                                            </span>
                                            <v-text-field
                                                id="email"
                                                v-model="email"
                                                name="email"
                                                :label="localize('email')"
                                                outlined
                                                dense
                                                :hide-details="true"
                                            ></v-text-field>
                                        </div>
                                    </ValidationProvider>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="12"
                                    :class="{
                                        'pr-0': $vuetify.breakpoint.mdAndUp,
                                        'pb-0': true, // $vuetify.breakpoint.smAndDown
                                    }"
                                >
                                    <ValidationProvider
                                        name="subject"
                                        rules="required"
                                        class="validationWrapper"
                                    >
                                        <div slot-scope="{ errors }">
                                            <span class="validationMessage">{{
                                                errors[0]
                                            }}</span>
                                            <v-select
                                                id="subject"
                                                v-model="subject"
                                                :items="queryOptions"
                                                name="subject"
                                                item-text="label"
                                                item-value="value"
                                                outlined
                                                dense
                                                :hide-details="true"
                                                :label="
                                                    localize('howCanWeHelp')
                                                "
                                            ></v-select>
                                        </div>
                                    </ValidationProvider>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="12"
                                    :class="{
                                        'pr-0': $vuetify.breakpoint.mdAndUp,
                                        'pb-0': true, // $vuetify.breakpoint.smAndDown
                                    }"
                                >
                                    <ValidationProvider
                                        name="message"
                                        rules="required"
                                        class="validationWrapper"
                                    >
                                        <div slot-scope="{ errors }">
                                            <span class="validationMessage">
                                                {{ errors[0] }}
                                            </span>
                                            <v-textarea
                                                id="message"
                                                v-model="message"
                                                name="nessage"
                                                :label="localize('message')"
                                                outlined
                                                dense
                                                :hide-details="true"
                                            ></v-textarea>
                                        </div>
                                    </ValidationProvider>
                                </v-col>
                                <v-col
                                    cols="12"
                                    :class="{
                                        'pr-0': $vuetify.breakpoint.mdAndUp,
                                        'pb-0': true, // $vuetify.breakpoint.smAndDown
                                    }"
                                >
                                    <recaptcha
                                        @success="onSuccess"
                                        @error="onError"
                                        @expired="onExpired"
                                    />
                                    <div
                                        v-if="captchaError"
                                        class="captcha-error"
                                    >
                                        <TranslatableStringComponent
                                            :tstring="{
                                                string: 'captchaRequired',
                                            }"
                                        />
                                    </div>
                                </v-col>
                                <v-col
                                    cols="12"
                                    :class="{
                                        'pr-0': $vuetify.breakpoint.mdAndUp,
                                        'pb-0': true, // $vuetify.breakpoint.smAndDown
                                    }"
                                >
                                    <v-btn
                                        type="submit"
                                        color="primary"
                                        right
                                        @click="scrollIntoView()"
                                        ><TranslatableStringComponent
                                            :tstring="{ string: 'submit' }"
                                    /></v-btn>
                                    <div v-if="sending">
                                        <TranslatableStringComponent
                                            :tstring="{
                                                string: 'submittingContactForm',
                                            }"
                                        />
                                    </div>
                                    <div v-if="waiting">
                                        <TranslatableStringComponent
                                            :tstring="{
                                                string: 'awaitingContactForm',
                                            }"
                                        />
                                    </div>
                                    <div v-if="success">
                                        <TranslatableStringComponent
                                            :tstring="{
                                                string: 'successfulContactForm',
                                            }"
                                        />
                                    </div>
                                    <div v-if="failure">
                                        <TranslatableStringComponent
                                            :tstring="{
                                                string: 'failedContactForm',
                                            }"
                                        />
                                    </div>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </ValidationObserver>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import { createHelpers } from 'vuex-map-fields'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { mapState } from 'vuex'
import { mask } from 'vue-the-mask'
import Cookies from 'js-cookie'
import { gtmEvent } from '~/plugins/global'
import encodeFormData from '~/mixins/encodeFormData'
import handleRecaptcha from '~/mixins/handleRecaptcha'
import handleSnackbar from '~/mixins/handleSnackbar'
import scrollIntoView from '~/mixins/scrollIntoView'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'

const { mapFields } = createHelpers({
    getterType: 'getContactField',
    mutationType: 'updateContactField',
})
export default {
    name: 'FormContact',
    components: {
        ValidationProvider,
        ValidationObserver,
        TranslatableStringComponent,
    },
    directives: {
        mask,
    },
    mixins: [encodeFormData, handleRecaptcha, handleSnackbar, scrollIntoView],
    data() {
        return {
            sending: false,
            waiting: false,
            success: false,
            failure: false,
            hints: {
                email: '',
            },
            captchaError: false,
            phoneMask: '(###) ###-####',
        }
    },
    computed: {
        ...mapState('formSelectOptions', ['queryOptions']),
        ...mapFields('contact', [
            'firstname',
            'lastname',
            'email',
            'phone',
            'company',
            'message',
            'subject',
        ]),
    },
    methods: {
        handleSubmission() {
            // https://stackoverflow.com/questions/25727306/request-header-field-access-control-allow-headers-is-not-allowed-by-access-contr
            if (!this.token) {
                this.captchaError = true
                return
            }
            this.sending = true
            this.waiting = false
            this.success = false
            this.failure = false
            const hubspotutk = Cookies.get('hubspotutk')
            const axiosConfig = {
                header: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            }
            // console.log('ROUTE!', this.$route)
            this.$axios
                .post('reCaptcha-server-side-validation', {
                    token: this.token,
                })
                .then((res) => {
                    // console.log('RECAPTCHA RESPONSE:', res)
                    if (res.data && res.data.success === false) throw res.data
                    this.$axios
                        .post(
                            process.env.V2_BASE_URL + '/contact/',
                            this.encode({
                                'form-name': 'contactForm',
                                // 'name.first': this.firstname,
                                // 'name.last': this.lastname,
                                // 'email': this.email,
                                // 'PhoneNumber.number': this.phone,
                                // 'name.company': this.company,
                                // 'customData.lastFormSubmissionMessage': this.message,
                                // 'customData.lastFormSubmissionSubject': this.subject,
                                ...this.$store.state.contact.contactForm,
                                hubspotutk,
                            }),
                            axiosConfig
                        )
                        .then((res) => {
                            // console.log('NETLIFY RESPONSE:', res.config.data)
                            // IF SUCCESS, SENDING=FALSE, AWAITING=TRUE
                            this.sending = false
                            this.waiting = true
                            this.$axios
                                .post(
                                    'submitted-web-form',
                                    res.config.data,
                                    axiosConfig
                                )
                                .then((response) => {
                                    // console.log('LAMBDA RESPONSE:', response)
                                    gtmEvent({
                                        gtm: this.$gtm,
                                        event: 'contactForm',
                                        eventType: 'form',
                                        atts: {
                                            ...this.$store.state.contact
                                                .contactForm,
                                        },
                                    })
                                    this.resetForm('contactForm')
                                    this.$recaptcha.reset()
                                    this.waiting = false
                                    this.success = true
                                })
                                .catch((error) => {
                                    console.log('lambda failure was', error)
                                    this.handleErrors()
                                })
                        })
                        .catch((err) => {
                            console.log(
                                'This order submission failed at Netify for some reason. Please try again. ERROR:',
                                err
                            )
                            this.handleErrors()
                        })
                })
                .catch((err) => {
                    const errorMessage = 'recaptchaFailedMessage'
                    console.log(errorMessage, err)
                    this.handleErrors(errorMessage)
                })
        },
        handleErrors(errorMessage) {
            this.$recaptcha.reset()
            this.loader = false
            this.sending = false
            this.waiting = false
            this.failure = true
            this.hitSnackbar({ string: errorMessage }, {})
        },
    },
}
</script>
